if (window.innerWidth < 750) {
    const pdpAdjustment = (element, callback) => {
        const maxWaitTime = 7000;
        const interval = 90;
        let elapsedTime = 0;

        const waitingInterval = setInterval(() => {
            const selector = document.querySelector(element);
            if (selector) {
                callback();
                clearInterval(waitingInterval);
            } else {
                elapsedTime += interval;
                if (elapsedTime >= maxWaitTime) {
                    clearInterval(waitingInterval);
                }
            }
        }, interval);
    };

    pdpAdjustment(".PS-001-product-info", () => {
        const judgemeBadge = document.querySelector(".PS-001-product-info .shopify-block .jdgm-preview-badge")
        judgemeBadge.classList.add("PS-016")
        const titleCont = document.querySelector(".PS-001-product-info-title")
        titleCont.classList.add("PS-016")
        const priceCont = document.querySelector(".price.price--large.price--show-badge")
        priceCont.classList.add("PS-016")
        productInfoWrapper.classList.add("PS-016")
        document.querySelector(".thumbnail-list.list-unstyled.slider.slider--mobile.slider--tablet-up").classList.add("PS-016")
        document.querySelector(".product__short-desc").classList.add("PS-016")

        document.querySelector(".grid__item.product__media-wrapper").before(judgemeBadge)
        document.querySelector(".grid__item.product__media-wrapper").before(titleCont)
        document.querySelector(".grid__item.product__media-wrapper").before(priceCont)

        const desc = document.querySelector('.product__short-desc-text .metafield-rich_text_field p');
        desc.innerHTML = desc.innerHTML.replace(
            /safe, natural, and plant-derived ingredients/,
            '<strong>safe, natural, and plant-derived ingredients</strong>'
        );

        const infoObserver = new MutationObserver(() => {
            var actualPrice = document.querySelector(".PS-001-product-info .price--large.price--show-badge .price-item.price-item--regular ").textContent
            document.querySelector(".PS-016 .PS-001-product-price").textContent = actualPrice
        })

        infoObserver.observe(productInfoWrapper, {
            subtree: true,
            childList: true,
        })

    });
}